import { useFeature } from '@optimizely/react-sdk';

import { USE_TOGGLE_ENROLLMENT_DOWN_PAGE } from 'consts/featureConsts';

const useDownTimePage = () => {
  const [shouldShowDownTimePage] = useFeature(
    USE_TOGGLE_ENROLLMENT_DOWN_PAGE.name
  );

  return shouldShowDownTimePage;
};

export default useDownTimePage;
